import { Box } from "@mui/material";
import { AMLData } from "@repo/logic";
import { FC, useMemo } from "react";

type PersonDetailAddressProps = {
    street?: string | null;
    houseNumber?: string | null;
    city?: string | null;
    country?: string | null;
    zipCode?: string | null;
    countryA3?: string | null;
};
export const PersonDetailAddress: FC<PersonDetailAddressProps> = ({
    street,
    houseNumber,
    city,
    country,
    zipCode,
    countryA3,
}) => {
    const countryName = useMemo(() => {
        if (!countryA3) return country;
        const found = AMLData.Countries.find((c) => c.country_code_a3 === countryA3);
        if (found?.country_name_cz) return found.country_name_cz;
        else return country;
    }, [country, countryA3]);

    return (
        <Box>
            {street ?? ""} {houseNumber ?? ""}
            <br />
            {zipCode ?? ""} {city ?? ""}
            <br />
            {countryName ?? ""}
        </Box>
    );
};
